import React, { useState, useEffect } from "react";
/** Services Import */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
/** Components Import */
import { Loading, Radio, Dropdown, Button } from "../../Components/Bootstrap";
import { Stack } from "react-bootstrap";

function EmptyCar() {
  const [loading, setLoading] = useState(false);
  const [radioValue, setRadioValue] = useState("");
  const [carList, setCarList] = useState([]);
  const [selectedCar, setSelectedCar] = useState("");

  useEffect(() => {
    Init();
  }, []);

  // 차량 콤보 조회
  const Init = async () => {
    setLoading(true);
    let _carList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Common.GetCode,
        {
          code: "VEHICLE",
          key1: "",
          key2: "",
          key3: "",
          key4: "",
        }
      ).then((result) => {
        let data = result.data;
        // console.log("차량 콤보 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _carList.push(data[i]);
          }
          setCarList(_carList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 공차 운행 시작
  const SaveLogic = async () => {
    setLoading(true);

    try {
      if (!radioValue) {
        throw new Error("공차 유형을 선택하세요.");
      } else if (!selectedCar) {
        throw new Error("차량 번호를 선택하세요.");
      }

      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.EmptyCar.Create,
        {
          vhcleId: selectedCar,
          opertDiv: radioValue,
        }
      ).then((result) => {
        let data = result.data;
        console.log("공차 운행 시작: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "Not Data") {
          throw new Error("데이터가 없습니다.");
        } else if (data === "Ok") {
          setRadioValue("");
          Init();
          Commons.Toast("success", "운행이 시작 되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 공차 운행 종료
  const SaveLogic1 = async () => {
    setLoading(true);

    try {
      if (!radioValue) {
        throw new Error("공차 유형을 선택하세요.");
      } else if (!selectedCar) {
        throw new Error("차량 번호를 선택하세요.");
      }

      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.EmptyCar.Cancel,
        {
          vhcleId: selectedCar,
          opertDiv: radioValue,
        }
      ).then((result) => {
        let data = result.data;
        console.log("공차 운행 종료: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "Not Data" || data === "Not Start Car") {
          throw new Error("시작한 차량이 없습니다.");
        } else if (data === "Ok") {
          setRadioValue("");
          Init();
          Commons.Toast("success", "운행이 종료 되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Stack>
        <div className="custom-dialog-inputs-container">
          <div className="vertical-divider" />
          <span style={{ marginLeft: "4px", color: "#0d6efd" }}>공차 운행</span>
        </div>
        <Radio
          divClassName="mb-3"
          items={[
            { value: "6", text: "정비" },
            { value: "5", text: "충전" },
            { value: "2", text: "사고" },
            { value: "3", text: "고장" },
          ]}
          value={radioValue}
          onChange={(e) => setRadioValue(e)}
        />
        <div className="custom-dialog-inputs-container">
          <span style={{ minWidth: "30%" }}>차량 번호</span>
          <Dropdown
            variant="outline-primary"
            title={"차량을 선택하세요."}
            items={carList}
            value={selectedCar}
            onChange={(e) => setSelectedCar(e)}
          />
        </div>
        <div className="custom-inputs-button-container mt-3">
          <Button title="공차 운행 시작" onClick={SaveLogic} />
          <Button title="공차 운행 종료" onClick={SaveLogic1} />
        </div>
      </Stack>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default EmptyCar;
